module.exports = __webpack_public_path__ + "ab4cba2e9303a157ab44138b9d897c2e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/curvy.png
// module id = 1200
// module chunks = 0